import { Layout, Menu } from "antd";
import React from "react";
import { Link, Route, Routes } from 'react-router-dom';
import "./App.css";
import Gpm from "./gpm/GPM";
import ProfileDetail from "./ProfileDetail";
import LinkAd from "./LinkAccount";
const { Header, Content } = Layout;
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const items = [
  getItem('', 'profile', <h3><Link to='/profile'>Profile GPM</Link></h3>),
  getItem('', 'link-acc', <h3><Link to='/link-acc'>Link Account</Link></h3>),
  // getItem('', 'bank', <h3><Link to='/bank'>Bank</Link></h3>),
  // getItem('', 'advertising', <h3><Link to='/advertising'>Advertising</Link></h3>),
  // getItem('', 'accounts', <h3><Link to='/accounts'>QLTK</Link></h3>),
];
function App() {
  return (
    <Layout>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: 'flex-start'
        }}
      >
        <Menu
          theme="dark"
          mode="horizontal"
          style={{ flex: 1, minWidth: 0 }}
          items={items}
        />
      </Header>
      <Content style={{ padding: "0 20px", minHeight: "80vh" }}>
        <Routes>
          <Route path='/' element={<Gpm />} />
          <Route path='/profile' element={<Gpm />} />
          <Route path='/profile/:id' element={<ProfileDetail />} />
          <Route path='/link-acc' element={<LinkAd />} />
          {/* <Route path='/bank' element={<BankComponent />} /> */}
          {/* <Route path='/advertising' element={<AdvertisingComponent />} /> */}
          {/* <Route path='/accounts' element={<ManagerAccountComponent />} /> */}
        </Routes>
      </Content>
    </Layout>
  );
}


export default App;